module.exports = __webpack_public_path__ + "img/13_003.bd30606e.webp";